<form #formCliente="ngForm">
  <div class="row">
    <div class="form-group">
      <span class="icon id-number"></span>
      <div class="inputs">
        <label for="cpf-clientef">CPF</label>
        <input
            name="cpf-cliente"
            type="text"
            class="form-control"
            [(ngModel)]="fichaCadastro._client.cpf"
            [disabled]="isValidatingClienteCpf"
            mask-number
            [mask]="'999.999.999-99'"
            placeholder="Digite apenas numeros"
            appCpfValidator
            required
            appShowErrorMessages
            requiredMessage="O Campo CPF é obrigatório"
            (blur)="getCpfCliente()"
            #cpfCliente="ngModel"
            />

        <div *ngIf="isValidatingClienteCpf">
          <em class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></em> Verificando CPF do Cliente...</div>
      </div>
    </div>
    <div class="form-group">
      <span class="icon user"></span>
      <div class="inputs">
        <label for="data-nascimento-cliente">Data de Nascimento</label>
        <input
            #dataNascimento
            name="data-nascimento-cliente"
            type="text"
            [(ngModel)]="fichaCadastro._client.dataNascimento"
            [disabled]="isValidatingClienteCpf"
            mask-number
            [mask]="'99/99/9999'"
            placeholder="00/00/0000"
            class="form-control"
            appDataValidator
            [dateRange]="dataRange"
            required
            appShowErrorMessages
        />
      </div>
    </div>
    <div class="form-group">
      <span class="icon mobile"></span>
      <div class="inputs">
        <label for="celular-cliente">Celular do cliente</label>
        <input
            name="celular-cliente"
            type="tel"
            [(ngModel)]="fichaCadastro._client.telefones.celular"
            [disabled]="isValidatingClienteCpf"
            required
            appShowErrorMessages
            minlength="11"
            maxlength="15"
            class="form-control"
            placeholder="(00) 00000-0000"
            appTelefone
        />
      </div>
    </div>
    <div class="form-group">
      <span class="icon income"></span>
      <div class="inputs">
        <label for="cliente-renda-comprovada">Renda Comprovada</label>
        <input
            name="cliente-renda-comprovada"
            type="text"
            class="form-control"
            placeholder="Digite apenas números"
            maxlength="17"
            required
            [disabled]="isValidatingClienteCpf"
            [(ngModel)]="fichaCadastro._client.renda"
            [prefix]="'R$'"
            mask-money
            appOnlyMoney
            appMoedaValidator
            appShowErrorMessages
        />
        <div class="marginT10 check-mod" (click)="onClickAvalista()">
          <label for="user-guarantor">
            <input
                type="checkbox"
                id="user-guarantor"
                name="q1"
                value="0"
                [disabled]="isValidatingClienteCpf"
                [(ngModel)]="fichaCadastro.isAvalista"
            />
            <span class="radio-label">Incluir Avalista</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</form>

<form #formAvalista="ngForm">
  <div class="blue-box guarantor" [ngClass]="{'dn': !fichaCadastro.isAvalista}">
    <h2>Informações do Avalista</h2>

    <div class="row">
      <div class="form-group">
        <span class="icon id-number"></span>
        <div class="inputs">
          <label for="cpf-avalista">CPF</label>
          <input
              name="cpf-avalista"
              type="text"
              class="form-control"
              [(ngModel)]="fichaCadastro._avalista.cpf"
              [disabled]="isValidatingClienteCpf"
              mask-number
              [mask]="'999.999.999-99'"
              placeholder="Digite apenas numeros"
              appCpfValidator
              required
              appShowErrorMessages
              requiredMessage="O Campo CPF é obrigatório"
              #cpfAvalista="ngModel"
              (blur)="getCpfAvalista()"
          />
          <div class="text-danger" *ngIf="cpfCliente.value && cpfAvalista.value == cpfCliente.value">o CPF do avalista não pode ser o mesmo do cliente  </div>
          <div *ngIf="isValidatingAvalistaCpf">
            <em class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></em> Verificando CPF do Avalista...
          </div>
        </div>
      </div>
      <div class="form-group">
        <span class="icon user"></span>
        <div class="inputs">
          <label for="avalista-data-nascimento">Data de Nascimento</label>
          <input
              type="text"
              name="avalista-data-nascimento"
              [(ngModel)]="fichaCadastro._avalista.dataNascimento"
              mask-number
              [mask]="'99/99/9999'"
              placeholder="00/00/0000"
              class="form-control"
              appDataValidator
              [dateRange]="dataRange"
              required
              appShowErrorMessages
          />
        </div>
      </div>
      <div class="form-group">
        <span class="icon mobile"></span>
        <div class="inputs">
          <label for="avalista-telefone-celular">Celular do avalista</label>
          <input
            name="avalista-telefone-celular"
            type="tel"
            [(ngModel)]="fichaCadastro._avalista.telefones.celular"
            [disabled]="isValidatingClienteCpf"
            required
            appShowErrorMessages
            minlength="11"
            maxlength="15"
            class="form-control"
            placeholder="(00) 00000-0000"
            appTelefone
          />
        </div>
      </div>
      <div class="form-group">
        <span class="icon income"></span>
        <div class="inputs">
          <label for="avalista-renda-comprovada">Renda Comprovada</label>
          <input
              name="avalista-renda-comprovada"
              type="text"
              class="form-control"
              placeholder="Digite apenas números"
              maxlength="17"
              required
              [disabled]="isValidatingClienteCpf"
              [(ngModel)]="fichaCadastro._avalista.renda"
              [prefix]="'R$'"
              mask-money
              appOnlyMoney
              appMoedaValidator
              appShowErrorMessages
          />
        </div>
      </div>
      <div class="form-group">
        <span class="icon reference"></span>
        <div class="inputs">
          <label for="parentesco-avalista">Relação com o Cliente</label>
          <select class="form-control" name="parentesco-avalista" required appShowErrorMessages [(ngModel)]="fichaCadastro._avalista.grauParentesco">
            <option value="" hidden selected>Selecione</option>
            <option value="1">Cônjuge</option>
            <option value="4">Filho / Filha</option>
            <option value="3">Irmã(o)</option>
            <option value="2">Pai / Mãe</option>
            <option value="0">Outro</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</form>
<div class="row">
  <div class="marginT30 form-group tab-buttons">
    <a (click)="onClickPrevious()" class="bt-back btn btn-border-orange pull-left">
      <em class="fa fa-arrow-left mrBt"></em> Voltar</a>
    <a class="bt-go btn btn-full-orange pull-right" [ngClass]="{'disabled': validateNextButton(formCliente.valid, formAvalista.valid) || cpfAvalista.value == cpfCliente.value}" (click)="onClickNext()">Continuar
      <em class="fa fa-arrow-right mlBt"></em>
    </a>
  </div>
</div>
<!-- Modal Seleção caso encontre ficha no CPF -->
<app-modal #modal title="ATENÇÃO" [ignoreBackdropClick]="true" [hideButtons]="true">
  <div class="modal-info">
    <h1>Existe uma ficha para esse CPF</h1>
    <h2>Você deseja</h2>
    <div class="buttons">
      <button (click)="recuperarFicha()" [disabled]="!showButtonRecuperaFicha" class="btn btn-full-orange">Recuperar a ficha</button>
      <button (click)="recuperarDados()"  class="btn btn-full-orange">Recuperar os dados</button>
      <button (click)="iniciarNovaFicha()" class="btn btn-full-orange">Iniciar nova ficha</button>
    </div>
  </div>
</app-modal>
<app-modal #modalAvalista title="ATENÇÃO" [ignoreBackdropClick]="true" [hideButtons]="true">
  <div class="modal-info">
    <h1>Existe avalista para este CPF</h1>
    <h2>Você deseja</h2>
    <div class="buttons">
      <button (click)="recuperarDadosAvalista()"  class="btn btn-full-orange">Recuperar os dados</button>
      <button (click)="continuar()" class="btn btn-full-orange">Continuar</button>
    </div>
  </div>
</app-modal>
